<template>
  <el-form
    ref="shipperForm"
    class="search-form"
    :inline="true"
    :model="form"
    label-width="110px"
  >
    <el-row :class="openMore ? 'search-bar-content-show' : 'search-bar-content-close'">
      <el-col :span="6">
        <el-form-item label="仓库ID/编码：">
          <el-input
            v-model="form.code"
            placeholder="请输入仓库ID/编码"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="仓库名称：">
          <el-input
            v-model="form.name"
            placeholder="请输入仓库名称"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="状态：">
          <el-select v-model="form.enabled">
            <el-option
              label="全部"
              :value="undefined"
            />
            <el-option
              label="启用"
              :value="true"
            />
            <el-option
              label="禁用"
              :value="false"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="支持温层：">
          <el-select v-model="form.temperatureLayerName">
            <el-option
              v-for="item in temper"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="是否自营：">
          <el-select v-model="form.ascriptionType">
            <el-option
              v-for="item in ASCRIPTION_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <div class="search-btns">
          <div class="moreData" @click="openMore = !openMore">
            {{ !openMore ? "展开筛选" : "收起筛选" }}
            <el-icon :class="openMore ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
          </div>
          <div class="form-btns">
            <el-button
              class="form-btn"
              type="primary"
              @click.native.prevent="fetchData"
            >
              查询
            </el-button>
            <el-button
              class="form-btn"
              @click.native.prevent="resetData()"
            >
              重置
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import {
  SHIPPERSTATUS,
  ASCRIPTION_TYPE,
} from '../constant';

export default {
  name: 'ListFilter',
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    temper: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      openMore: false,
      SHIPPERSTATUS, // 货主状态列表
      ASCRIPTION_TYPE, // 是否自营
    };
  },
  computed: {
  },
  methods: {
    fetchData() {
      this.$emit('fetchData');
    },
    resetData() {
      this.$emit('resetData');
    },
  },
};
</script>

<style lang="scss" scoped>
.search-btns {
  float: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .moreData {
    font-size: 12px;
    color: #606266;
    margin-right: 28px;
    &:hover {
      cursor: pointer;
    }
    [class*=" el-icon-"],
    [class^="el-icon-"] {
      color: #059E84 !important;
      font-family: "element-icons" !important;
    }
  }
}
.search-form ::v-deep {
  .el-col {
    margin: 12px 0;
    .el-form-item {
      width: 100%;
      margin: 0;
      .el-form-item__label {
        white-space: nowrap;
        overflow: hidden;
      }
      .el-form-item__content {
        width: calc(100% - 128px);
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
.search-bar-content-close::v-deep {
  .el-col {
    display: none !important;
  }
  .el-col:nth-child(1) {
    display: block !important;
  }
  .el-col:nth-child(2) {
    display: block !important;
  }
  .el-col:nth-child(3) {
    display: block !important;
  }
  .el-col:nth-last-child(1) {
    float: right !important;
    display: block !important;
  }
}
.search-bar-content-show::v-deep {
  .el-col:nth-last-child(1) {
    float: right !important;
  }
}
</style>
